import {
  GET_COUPONS,
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FAIL,
  GET_COUPON,
  GET_COUPON_SUCCESS,
  GET_COUPON_FAIL,
  CREATE_COUPON,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_FAIL,
  UPDATE_COUPON,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_FAIL,
  DELETE_COUPON,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL,
  CLEAR_COUPON_ERROR,
  CLEAR_SELECTED_COUPON,
} from "./actionTypes"

// Get all coupons with pagination and filters
export const getCoupons = (params, history) => ({
  type: GET_COUPONS,
  payload: { params, history },
})

// Get coupon by ID
export const getCoupon = (couponId, history) => ({
  type: GET_COUPON,
  payload: { couponId, history },
})

// Create new coupon
export const createCoupon = (coupon, history) => ({
  type: CREATE_COUPON,
  payload: { coupon, history },
})

// Update coupon
export const updateCoupon = (couponId, coupon, history) => ({
  type: UPDATE_COUPON,
  payload: { couponId, coupon, history },
})

// Delete coupon
export const deleteCoupon = (couponId, history) => ({
  type: DELETE_COUPON,
  payload: { couponId, history },
})

// Clear coupon errors
export const clearCouponError = () => ({
  type: CLEAR_COUPON_ERROR,
})

// Clear selected coupon
export const clearSelectedCoupon = () => ({
  type: CLEAR_SELECTED_COUPON,
})
